var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"app-container reporter-recommend"},[_c('CollectionDetail',{attrs:{"as-component":"","title":"推荐记者"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }